import { Box } from "@mui/material";
import React from "react";

const WidgetDesignCard = ({ src }) => {
  return (
    <Box>
      <img width={"300px"} height={"400px"} src={src} alt="" />
    </Box>
  );
};

export default WidgetDesignCard;
